import './main.less';
import { actions, selectors } from '../../../../modules/dashboard';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

// local
import Charts from './components/charts';
import Contest from './components/contest';
import Banner from '../../../../modules/shared/banner/main';

// shared
import renderViewsState from '../../../../modules/shared/render-views-state';
import Animate from '../../../../modules/shared/animation';
import PaginationArrowControl from '../../../../modules/shared/pagination/arrows-control';
import PaginationBulletControl from '../../../../modules/shared/pagination/bullet-control';
import Offers from '../../../../modules/dashboard/components/offers';
import News from '../../../../modules/dashboard/components/news';
import Manager from '../../../../modules/shared/manager';
import Polls from '../../../../modules/dashboard/components/polls';

const Main = renderViewsState(props => {
	const { intl } = props;

	return (
		<div className="dashboard container container__with-columns">
			{
				props.user.general.status === 'banned' &&
				<div className="alert"><span>{intl('Ваш аккаунт заблокирован')}</span></div>
			}
			{
				props.user.general.status === 'not_confirmed' &&
				<div className="alert">
					<span>{intl('Пожалуйста, подтвердите свой Email, чтобы иметь возможность заказывать выплаты')}</span>
				</div>
			}

			<div className="column_left">
				<Polls {...props} />
				{window.globalConfig.isRocketBannerEnabled ? (
					<Banner
						className='stat-banner'
						banner={props.banners[1]}
					/>
				) : (
					<Charts
						className='dashboard-charts'
						{...props}
					/>
				)}
				{moment().isBetween(moment('2023-11-21 00:00:00.000+03'), moment('2023-12-22 00:00:00.000+03')) && (
					<Contest intl={intl} {...props.contest} />
				)}
				<div className="container__content">
					<div className="container__content-title">
						<h2 className="font-proxima-nova-bold">{intl('Новые офферы')}</h2>
						<PaginationArrowControl
							paginatedComponentName='offers'
							paginationActions={props.pagination()}
							nextPage={props.offers.nextPageNumber}
							prevPage={props.offers.prevPageNumber}
							isCanNotMoveToNext={props.offers.isCanNotMoveToNext}
							isCanNotMoveToPrev={props.offers.isCanNotMoveToPrev}/>
					</div>
					<Animate>
						<Offers key={props.offers.currentPage}
							data={props.offers.data}
							currenciesForOffers={props.currenciesForOffers}
							changeActiveCurrency={props.changeActiveCurrency}
							setQuidActive={props.setQuidActive}
							intl={intl} />
					</Animate>
					<PaginationBulletControl
						paginatedComponentName='offers'
						paginationActions={props.pagination()}
						totalPage={props.offers.totalPages}
						currentPage={props.offers.currentPage}/>
				</div>

				<div className="container__content">
					<div className="container__content-title">
						<h2 className="font-proxima-nova-bold">{intl('Новости')}</h2>
						<PaginationArrowControl
							paginatedComponentName='news'
							paginationActions={props.pagination()}
							nextPage={props.news.nextPageNumber}
							prevPage={props.news.prevPageNumber}
							isCanNotMoveToNext={props.news.isCanNotMoveToNext}
							isCanNotMoveToPrev={props.news.isCanNotMoveToPrev}
							onActionCallback={props.closeOpenedNews}/>
					</div>
					<News
						key={props.news.currentPage}
						data={props.news.data}
						openedNewsOffers={props.openedNewsOffers}
						newsTypesEnum={props.newsTypesEnum}
						openedNewsId={props.openedNewsId}
						toggleNews={props.toggleNews}
						intl={intl} />
				</div>
			</div>
			<div className="column_right">
				{ !isEmpty(props.manager) && <Manager data={props.manager} user={props.user} intl={intl} />  }
				<Banner
					className='side-banner'
					banner={props.banners[2]}
				/>
				<Banner
					className='side-banner'
					banner={props.banners[3]}
				/>
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		user: selectors.getUserData(state),
		offers: selectors.getOffers(state),
		news: selectors.getNews(state),
		newsTypesEnum: selectors.getNewsTypesEnum(),
		openedNewsId: selectors.getOpenedNewsId(state),
		openedNewsOffers: selectors.getOpenedNewsOffers(state),
		manager: selectors.getManager(state),
		charts: selectors.getCharts(state),
		banners: selectors.getBanners(state),
		contest: selectors.getContest(state),
		pollUrl: selectors.getPollUrl(state),
		currenciesForOffers: selectors.getCurrenciesForOffers(state),
		masterAccountDisplayStatsConfig: selectors.getMasterAccountDisplayStatsConfig(state),
		intl: selectors.getIntl(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/dashboard/main.js